import React from 'react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import DaySpacingFields from 'components/actionBar/ActionBarCalendar/components/DaySpacingFields';
import Switch from 'components/common/Switch';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const GridSpacingSection = ({ calendar, onChange }) => {
  return (
    <SettingsSection title="Grid spacing">
      <DaySpacingFields shape={calendar} onChange={onChange} fieldClassName={c.field} />
      <div className={c.debugSettingRow}>
        <Switch
          id="calendar-grid-spacing-debug-guides"
          className={c.debugSwitch}
          checked={calendar.showGridSpacingDebugGuides === true}
          onChange={() => onChange({ showGridSpacingDebugGuides: calendar.showGridSpacingDebugGuides !== true })}
          label="Show debug guides"
          aria-label="Show grid spacing debug guides"
        />
        <button
          type="button"
          className={c.infoButton}
          aria-label="About grid spacing debug guides"
          data-for="calendarGridSpacingDebugGuidesTooltip"
          data-tip="Shows dashed boundaries inside day cells after grid spacing, for debugging in admin mode. These guides are not part of the final design."
        >
          <FontAwesomeIcon.Memo icon={faCircleInfo} />
        </button>
        <ReactTooltip id="calendarGridSpacingDebugGuidesTooltip" place="right" type="dark" effect="solid" />
      </div>
    </SettingsSection>
  );
};

export default GridSpacingSection;
